import CardMarketPlaceTypes from 'store/actionTypes/cardMarketPlace'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  components: {
    list: [],
    pagination: {}
  }
}

const cardMarketPlace = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case CardMarketPlaceTypes.GET_CARD_MARKET_PLACES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload
      }
    case CardMarketPlaceTypes.UPDATE_FILTER_CARD_MARKET_PLACE_SUCCESS:
      return { ...state, filter: payload }

    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default cardMarketPlace
